module.exports = __webpack_public_path__ + "assets/img/headLogo.32b27292.png";